import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Layout from "./Layout";
import Login from "./Login/Login";
import List from "./List";
import Setting from "./Setting";
import Dashboard from "./Dashboard";
import NotFound from "./NotFound";
import Error from "./Error";
import Camera from "./Camera";
import DemoList from "./Demo/DemoList.js";
import DemoDashboard from "./Demo/DemoDashboard.js";
import cookie from "react-cookies";
import History from "./History/History";

class Index extends React.Component {
  render() {
    let auto = [{ value: false }];
    if (localStorage.getItem("accessToken")) {
      auto = JSON.parse(localStorage.getItem("accessToken"));
    }

    return (
      <>
        <Layout>
          <Router>
            <Switch>
              {cookie.load("autoLogin") || auto.value ? (
                <Route path="/" exact={true} component={List} />
              ) : (
                <Route path="/" exact={true} component={Login} />
              )}
              <Route path="/list" exact={true} component={List} />
              <Route path="/setting" exact={true} component={Setting} />
              <Route path="/square" exact={true} component={Dashboard} />
              <Route path="/camera" exact={true} component={Camera} />
              <Route path="/demolist" exact={true} component={DemoList} />
              <Route
                path="/demosquare"
                exact={true}
                component={DemoDashboard}
              />
              <Route path="/history" exact={true} component={History} />
              {/* Error Page */}
              <Route path="/error" exact={true} component={Error} />
              {/* 404 Page */}
              <Route component={NotFound} />
            </Switch>
          </Router>
        </Layout>
      </>
    );
  }
}

export default Index;
